import { render } from "./SvgObject.vue?vue&type=template&id=28da76ee&scoped=true"
import script from "./SvgObject.vue?vue&type=script&lang=js"
export * from "./SvgObject.vue?vue&type=script&lang=js"

import "./SvgObject.vue?vue&type=style&index=0&id=28da76ee&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-28da76ee"

export default script